import { Link, Action, linkFields } from '../../core/Link';
import * as THREE from 'three';
import { forwardRef } from 'react';

// Create a reusable Audio Link component
const AudioLinkComponent = forwardRef<THREE.Object3D, { properties: any; isPreview?: boolean }>((props, ref) => {
  // Audio links don't have a visual representation, so we return null
  return null;
});

// Default action for audio links
const defaultAction: Action = {
  id: crypto.randomUUID(),
  name: 'Audio Reactive Action',
  type: 'minmax',
  targetItemId: '',
  targetProperty: '',
  range: {
    min: 0,
    max: 1
  },
  enabled: true,
  easing: 'linear',
  curve: 'linear'
};

export const AudioLinkItem: Link = {
  id: '',
  name: 'Audio Link',
  type: 'link',
  linkType: 'audio',
  icon: 'Music',
  settings: {
    audioSource: 'microphone1',
    analysisType: 'amplitude',
    threshold: 0.5
  },
  actions: [defaultAction],
  properties: {
    enabled: true,
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 }
  },
  fields: [
    ...linkFields.common,
    ...linkFields.audio
  ],
  render: (properties, isPreview, ref) => {
    return null; // Audio links don't have a visual representation
  }
};
